import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=08dbabfc&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"
import style0 from "./Galeria.vue?vue&type=style&index=0&id=08dbabfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbabfc",
  null
  
)

export default component.exports